export default __webpack_public_path__ + "static/media/edit-white.0e3958e2.svg";